import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TempInvoiceConfirmationEditor.html?raw';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import lang from 'dojo/_base/lang';
import { ExpandableSection, ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../moreCore/Tools/EntityStore';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import Edit from '../../moreCore/UI/Edit/Edit';
import DateInput from '../../moreCore/UI/DateInput/DateInput';
import FileUpload from '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import { FileUploadTypes } from "../../moreCore/UI/Filetransfer/FileUpload/FileUploadTypes";
import { VAM2types } from "../_loadingHelpers/VAMv2Types";
import FileUploadDisplay_ListRow from '../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow';
import PageStack from '../../moreCore/UI/Tabbing/PageStack';
import RadioGroup from '../../moreCore/UI/RadioGroup/RadioGroup';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../moreCore/UI/HintBox/HintBox';

class TempInvoiceConfirmationEditor extends compose(_StatefulSection, _uiFrameMixin) {
    templateString: any = template;

    private fileCategories;
    private fileUpload: MdsLax<InstanceType<typeof FileUpload>>;
    private uploadUnits: Array<VAM2types.FileUploadWithCategories>
    private removedFiles: Array<string>;

    private uploadedFilesStore: MdsLax<InstanceType<typeof EntityStore<any>>>;
    private pagestack: MdsLax<InstanceType<typeof PageStack>>;


    private inputSalutation: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputNameFirst: MdsLax<InstanceType<typeof Edit>>;
    private inputNameLast: MdsLax<InstanceType<typeof Edit>>;
    private inputDayOfBirth: MdsLax<InstanceType<typeof DateInput>>;
    private inputStreet: MdsLax<InstanceType<typeof Edit>>;
    private inputMail: MdsLax<InstanceType<typeof Edit>>;
    private inputPhone: MdsLax<InstanceType<typeof Edit>>;
    private inputMobile: MdsLax<InstanceType<typeof Edit>>;
    private inputGvl: MdsLax<InstanceType<typeof Edit>>;
    private inputIBAN: MdsLax<InstanceType<typeof Edit>>;
    private inputAccountNo: MdsLax<InstanceType<typeof Edit>>;

    private inputNewAddressDescription: MdsLax<InstanceType<typeof Edit>>;
    private inputNewAddressName: MdsLax<InstanceType<typeof Edit>>;
    private inputNewAddressStreet: MdsLax<InstanceType<typeof Edit>>;

    private inputPostalCodeExisting: MdsLax<InstanceType<typeof HintBox>>;
    private inputCityExisting: MdsLax<InstanceType<typeof HintBox>>;
    private inputCountryExisting: MdsLax<InstanceType<typeof HintBox>>;

    private inputPostalCodeNew: MdsLax<InstanceType<typeof HintBox>>;
    private inputCityNew: MdsLax<InstanceType<typeof HintBox>>;
    private inputCountryNew: MdsLax<InstanceType<typeof HintBox>>;

    private inputIsNewAccount: MdsLax<InstanceType<typeof CheckBox>>;
    private inputBankNo: MdsLax<InstanceType<typeof HintBox>>;
    private inputBIC: MdsLax<InstanceType<typeof HintBox>>;
    private inputAccountOwner: MdsLax<InstanceType<typeof HintBox>>;

    private inputArrivalFrom: MdsLax<InstanceType<typeof Edit>>;
    private inputReturnBackTo: MdsLax<InstanceType<typeof Edit>>;
    private inputDateArrival: MdsLax<InstanceType<typeof DateInput>>;
    private inputDateDeparture: MdsLax<InstanceType<typeof DateInput>>;

    private inputModeOfTransportation: MdsLax<InstanceType<typeof RadioGroup>>;


    private sectionEuropeanAccount: HTMLDivElement;
    private sectionNonEuropeanAccount: HTMLDivElement;
    private sectionAlternativeTaxAddress: HTMLDivElement;
    private sectionPlaceOfLiving: HTMLDivElement;
    private sectionPersonalVehicle: HTMLDivElement;
    private sectionTravelAmount: HTMLDivElement;
    private sectionHotel: HTMLDivElement;

    private bookingTableContainer: MdsLax<InstanceType<typeof ExpandableSection>>;
    private bookingsTable: MdsLax<InstanceType<typeof StaticTable>>;
    private bookingsStore: MdsLax<InstanceType<typeof EntityStore<any>>>;


    private _rowConfigBookings: StaticTable.RowConfig = {
        attributes: [
            "date_start",
            "date_end",
            "ref_ev_room.description",
            "ev_booking_name"
        ],
        colNamesInternal: [
            "date_start",
            "date_end",
            "ref_ev_room.description",
            "ev_booking_name"
        ],
        headings: [
            (this as any).translate("TempInvoiceConfirmationEditor_Label_DateStart"),
            (this as any).translate("TempInvoiceConfirmationEditor_Label_DateEnd"),
            (this as any).translate("TempInvoiceConfirmationEditor_Label_EvRoom"),
            (this as any).translate("TempInvoiceConfirmationEditor_Label_BookingName")
        ]
    }

    private _layoutBookings: StaticTable.Layout = {
        label: "bookingTable",
        name: "bookingTable",
        rows: [(this as any)._rowConfigBookings]
    }

    private _setupBookingsTable() {
        this.bookingsTable = new StaticTable();
        this.bookingsTable.addLayout(this._layoutBookings);
        this.bookingsTable.setupFromStore(this.bookingsStore);
        this.bookingsTable.setCyAttribute("TempInvoiceConfirmationEditorBookingTable");
        this.bookingsTable.placeAt(this.bookingTableContainer);
    }

    private filesTableContainer: HTMLDivElement;
    private filesTable: MdsLax<InstanceType<typeof StaticTable>>;
    private filesStore: MdsLax<InstanceType<typeof EntityStore<any>>>;

    private _rowConfigFiles: StaticTable.RowConfig = {
        attributes: [
            "keyword",
            "ref_file_category.description",
        ],
        colNamesInternal: [
            "keyword",
            "ref_file_categpry.description",
        ],
        headings: [
            (this as any).translate("TempInvoiceConfirmationEditor_Label_FileKeyword"),
            (this as any).translate("TempInvoiceConfirmationEditor_Label_FileCategory"),
        ]
    }

    private _layoutFiles: StaticTable.Layout = {
        label: "filesTable",
        name: "filesTable",
        rows: [(this as any)._rowConfigFiles]
    }

    private _setupFilesTable() {
        this.filesTable = new StaticTable();
        this.filesTable.addLayout(this._layoutFiles);
        this.filesTable.setupFromStore(this.filesStore);
        this.filesTable.setCyAttribute("TempInvoiceConfirmationEditorFilesTable");
        this.filesTable.placeAt(this.filesTableContainer);
    }




    setup(entity: any, tabContainer: string) {
        this.internalName = "TempInvoiceConfirmationEditor_" + entity.ID;
        this.show("tab", entity.$Displayname, tabContainer);
        this.setStartupState("loading")
        this._loadData(entity.ID);
    }

    private _loadData(entityId: string) {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_TempInvoiceConfirmationEditor_LoadData",
            { entityId: entityId },
            lang.hitch(this, this._onLoadDataResponse),
            lang.hitch(this, this._onLoadDataError)
        )
    }

    private _onLoadDataResponse(response: any) {
        this.StandbyStop();
        this.setData(response);
    }

    private _onLoadDataError(error) {
        this.StandbyStop();
        console.error();
    }

    private isValidData(): boolean {
        let mandatoyinputs = this.checkMandatoryInputs();
        if (!this.checkMandatoryInputs()) {
            this.showToast(this.translate("TempInvoiceConfirmationEditor_Error_MandatoryInput"), "fas fa-exclamation-triangle");
            return false;
        }
        let modeOfTransportation = this.getAttributeValue("means_of_transport");
        let amountTravel = this.getAttributeValue("amount_travel")
        if ((modeOfTransportation === "plane" && amountTravel) || (modeOfTransportation === "train" && amountTravel)) {
            if (!this.storeHasFileOfType(modeOfTransportation)) {
                this.showToast(this.translate("TempInvoiceConfirmationEditor_Error_Transportation"), "fas fa-exclamation-triangle");
                return false;
            }
        }

        let hotel = this.getAttributeValue("hotel_stay");
        let amountHotel = this.getAttributeValue("amount_hotel")
        if (hotel === "private_booking" && amountHotel) {
            if (!this.storeHasFileOfType("hotel")) {
                this.showToast(this.translate("TempInvoiceConfirmationEditor_Error_Hotel"), "fas fa-exclamation-triangle");
                return false;
            }
        }
        
        return true;
    }

    private storeHasFileOfType(mode: string): boolean {
        let completelist = this.uploadedFilesStore.getCurrentCompleteList();
        let fileCategory;

        switch (mode) {
            case "plane":
            case "train":
                fileCategory = "00000334:000000bb";
                break;
            case "hotel":
                fileCategory = "00000334:000000bc";
                break;
        }

        for (let file of completelist) {
            if (file.ref_file_category.ID === fileCategory) return true;
        }
        return false;
    }

    private _onClickSave() {
        if (!this.isValidData()) {
            return;
        }
        let data = this.getChangedData();
        data.residence = this.getAttributeValue("residence");
        data.means_of_transport = this.getAttributeValue("means_of_transport");
        data.hotel_stay = this.getAttributeValue("hotel_stay");
        if(!data.bankAccount) data.bankAccount = {};
        data.bankAccount.ID = this.getAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.ID")
        data.bankAccount.is_new_account = this.getAttributeValue("is_new_account");
        data.bankAccount.is_european_account = this.getAttributeValue("is_european_account");
        let payload = { data, ID: this.getAttributeValue("musician_planning.ID") }

        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API__TempInvoiceConfirmationEditor_SaveData",
            payload,
            lang.hitch(this, this._onSaveResponse),
            lang.hitch(this, this._onSaveError)
        );
    }

    private _onSaveResponse(response) {
        this.StandbyStop();
        this.showToast(this.translate("TempInvoiceConfirmationEditor_Success_Save"), "fas fa-check");
        this.close();
    }

    private _onSaveError(error) {
        this.StandbyStop();
        this.showToast(this.translate("TempInvoiceConfirmationEditor_Error_Save"), "fas fa-exclamation-triangle");
    }

    protected onDirtyChange(newState: boolean) {
        this.enableButton("save", newState);
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        this.setStartupState("ready")

        this.setAttributeValue("is_european_account", true)

        let bookings = this.getAttributeValue("bookings");
        this.bookingsStore.setup(bookings);
        this.bookingTableContainer.setMarking(bookings.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
        this.bookingTableContainer.toggleExpand(true);

        let postalCode = this.getAttributeValue("musician_planning.ref_associate.ref_person.ref_postal_code");
        if (!postalCode) {
            let cPostalCode = this.getAttributeValue("musician_planning.ref_associate.ref_person.c_postal_code");
            let cCity = this.getAttributeValue("musician_planning.ref_associate.ref_person.c_city");
            if(cPostalCode) this.inputPostalCodeExisting.setPlainValue(cPostalCode, true);
            if(cCity) this.inputCityExisting.setPlainValue(cCity, true);
        }

        let bic = this.getAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.ref_bank");
        if (!bic) {
            let cBic = this.getAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.c_bank_BIC");
            if (cBic) this.inputBIC.setPlainValue(cBic, true);
        }

        this._setInputCountryReadonly("existing");

        let files = this.getAttributeValue("files");
        this.filesStore.setup(files);

        let isInputConfirmed = this.getAttributeValue("musician_planning.is_input_confirmed");
        if (isInputConfirmed) {
            this.pagestack.activatePageByName("files_default");
            this.pagestack.disablePage("upload");
        } else {
            this.pagestack.activatePageByName("upload");
            this.pagestack.disablePage("files_default");
        }

        if (isInputConfirmed) this.removeButton("save");

        this.setAttributeValue("amount_plane", 0);
        this.setAttributeValue("amount_train", 0);
        this.setAttributeValue("amount_hotel", 0);
        this.setAttributeValue("hotel_stay", "private_accommodation");
        this.setAttributeValue("means_of_transport", "none");

        this.setAttributeValue("is_new_account", false);

        let residence = this.getAttributeValue("musician_planning.residence");
        switch (residence) {
            case 1:
                this.setAttributeValue("residence", "berlin");
                break;
            case 2:
                this.setAttributeValue("residence", "germany");
                break;
            case 3:
                this.setAttributeValue("residence", "international");
                break;
        }


        let meansOfTransport = this.getAttributeValue("musician_planning.means_of_transport");
        switch (meansOfTransport) {
            case 1:
                this.setAttributeValue("means_of_transport", "none");
                break;
            case 2:
                this.setAttributeValue("means_of_transport", "personalVehicle");
                break;
            case 3:
                this.setAttributeValue("means_of_transport", "train");
                break;
            case 4:
                this.setAttributeValue("means_of_transport", "plane");
                break;
        }

        let hotelStay = this.getAttributeValue("musician_planning.hotel_stay");
        switch (hotelStay) {
            case 1:
                this.setAttributeValue("hotel_stay", "private_accommodation");
                break;
            case 2:
                this.setAttributeValue("hotel_stay", "company_booking");
                break;
            case 3:
                this.setAttributeValue("hotel_stay", "private_booking");
                break;
        }

        let amountTravel = this.getAttributeValue("musician_planning.amount_travel");
        this.setAttributeValue("amount_travel", amountTravel);

        let amountHotel = this.getAttributeValue("musician_planning.amount_hotel");
        this.setAttributeValue("amount_hotel", amountHotel);

        let dateArrival = this.getAttributeValue("musician_planning.date_arrival");
        this.setAttributeValue("date_arrival", dateArrival);

        let dateDeparture = this.getAttributeValue("musician_planning.date_departure");
        this.setAttributeValue("date_departure", dateDeparture);

        let noteSubstitute = this.getAttributeValue("musician_planning.note_substitute");
        this.setAttributeValue("note_substitute", noteSubstitute);

        let kilometersDriven = this.getAttributeValue("musician_planning.kilometers_driven")
        this.setAttributeValue("kilometers_driven", kilometersDriven);

        let inputConfirmed = this.getAttributeValue("musician_planning.is_input_confirmed");
        this.setAttributeValue("is_input_confirmed", inputConfirmed);
        if (inputConfirmed) this.setReadonly(true);

        let bankAccount = this.getAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account");
        if (!bankAccount) {
            this.setAttributeValue("is_new_account", true);
            this.inputIsNewAccount.setReadonly(true);
            let person = this.getAttributeValue("musician_planning.ref_associate.ref_person");
            this.inputAccountOwner.setValue(person, true);
        }
        if (bankAccount && !bankAccount.IBAN && bankAccount.account_no) this.setAttributeValue("is_european_account", false);
    }

    protected _onChanged(attribute: string, value: any) {
        switch (attribute) {
            case "is_european_account":
                this.hideNode(this.sectionNonEuropeanAccount, value);
                this.hideNode(this.sectionEuropeanAccount, !value);

                if (value) {
                    this.inputAccountNo.setMandatory(false);
                    //this.inputBankNo.setMandatory(false);

                    this.inputIBAN.setMandatory(true)
                } else {
                    this.inputAccountNo.setMandatory(true);
                   // this.inputBankNo.setMandatory(true);

                    this.inputIBAN.setMandatory(false)
                }
                break;
            case "is_new_account":
                if (value) {
                    this.setAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.IBAN", "");
                    this.setAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.account_no", "");
                    this.setAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.ref_bank", null);
                    this.setAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.c_bank_BIC", "");
                } else {
                    let bankAccount = this.getAttributeValue("musician_pannuing.ref_associate.ref_person.ref_main_bank_account");
                    if (bankAccount) {
                        let iban = this.sourceData.musician_planning.ref_associate.ref_person?.ref_main_bank_account.IBAN;
                        this.setAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.IBAN", iban);
                        let bank = this.sourceData.musician_planning.ref_associate.ref_person.ref_main_bank_account.ref_bank ? this.sourceData.musician_planning.ref_associate.ref_person.ref_main_bank_account.ref_bank : null;
                        this.setAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.ref_bank", bank);
                        let account_no = this.sourceData.musician_planning.ref_associate.ref_person?.ref_main_bank_account.account_no;
                        this.setAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.account_no", account_no);
                        let c_bank_BIC = this.sourceData.musician_planning.ref_associate.ref_person?.ref_main_bank_account.c_bank_BIC;
                        this.setAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.c_bank_BIC", c_bank_BIC);

                        let bic = this.getAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.ref_bank");
                        if (!bic) {
                            let cBic = this.getAttributeValue("musician_planning.ref_associate.ref_person.ref_main_bank_account.c_bank_BIC");
                            if (cBic) this.inputBIC.setPlainValue(cBic, true);
                        }
                    }
                }
                break;
            case "residence":
                if (value == "berlin") {
                    this.hideNode(this.sectionPlaceOfLiving, true);

                    this.inputArrivalFrom.setMandatory(false);
                    this.inputReturnBackTo.setMandatory(false);
                    this.inputDateArrival.setMandatory(false);
                    this.inputDateDeparture.setMandatory(false);
                } else {
                    this.hideNode(this.sectionPlaceOfLiving, false);

                    this.inputArrivalFrom.setMandatory(true);
                    this.inputReturnBackTo.setMandatory(true);
                    this.inputDateArrival.setMandatory(true);
                    this.inputDateDeparture.setMandatory(true);
                }
                break;
            case "means_of_transport":
                switch (value) {
                    case "none":
                        this.hideNode(this.sectionPersonalVehicle, true);
                        this.hideNode(this.sectionTravelAmount, true);
                        break;
                    case "personalVehicle":
                        this.hideNode(this.sectionPersonalVehicle, false);
                        this.hideNode(this.sectionTravelAmount, true);
                        break;
                    case "train":
                        this.hideNode(this.sectionPersonalVehicle, true);
                        this.hideNode(this.sectionTravelAmount, false);
                        break;
                    case "plane":
                        this.hideNode(this.sectionPersonalVehicle, true);
                        this.hideNode(this.sectionTravelAmount, false);
                        break;
                }
                break;
            case "hotel_stay":
                if (value === "private_booking") {
                    this.hideNode(this.sectionHotel, false);
                }
                else {
                    this.hideNode(this.sectionHotel, true);
                }
                break;
            case "is_alternative_tax_address":
                if (value) this.hideNode(this.sectionAlternativeTaxAddress, false);
                else this.hideNode(this.sectionAlternativeTaxAddress, true);

                if (value) {
                    this.inputNewAddressDescription.setMandatory(true);
                    this.inputNewAddressName.setMandatory(true);
                    this.inputNewAddressStreet.setMandatory(true);
                    this.inputPostalCodeNew.setMandatory(true);
                    this.inputCityNew.setMandatory(true);
                    this.inputCountryNew.setMandatory(true);
                } else {
                    this.inputNewAddressDescription.setMandatory(false);
                    this.inputNewAddressName.setMandatory(false);
                    this.inputNewAddressStreet.setMandatory(false);
                    this.inputPostalCodeNew.setMandatory(false);
                    this.inputCityNew.setMandatory(false);
                    this.inputCountryNew.setMandatory(false);
                }
            case "musician_planning.ref_associate.ref_person.ref_salutation":
                console.log(value);
                break; 
        }
    }

    private _setInputCountryReadonly(mode: "new" | "existing") {
        let isCityPlaintext: boolean;
        let isPostalCodePlaintext: boolean;
        let inputCity: MdsLax<InstanceType<typeof HintBox>>;
        let inputPostalCode: MdsLax<InstanceType<typeof HintBox>>;
        let inputCountry: MdsLax<InstanceType<typeof HintBox>>;

        switch (mode) {
            case "existing":
                inputCity = this.inputCityExisting;
                inputPostalCode = this.inputPostalCodeExisting;
                inputCountry = this.inputCountryExisting;
                break;
            case "new":
                inputCity = this.inputCityNew;
                inputPostalCode = this.inputPostalCodeNew;
                inputCountry = this.inputCountryNew;
                break;
        }

        isCityPlaintext = inputCity.valueIsPlaintext;
        isPostalCodePlaintext = inputPostalCode.valueIsPlaintext;

        let valueCity = inputCountry.getValue("entity");
        let valuePostalCode = inputPostalCode.getValue("entity");

        if (isCityPlaintext && isPostalCodePlaintext) inputCountry.setReadonly(false);
        else if (!valueCity && !valuePostalCode) inputCountry.setReadonly(false);
        else if (!valueCity && isPostalCodePlaintext) inputCountry.setReadonly(false);
        else if (!valuePostalCode && isCityPlaintext) inputCountry.setReadonly(false);
        else inputCountry.setReadonly(true);
    }

    private _onChangePostalCodeExisting() {
        let isPlaintext = this.inputPostalCodeExisting.valueIsPlaintext;
        let value;
        if (!isPlaintext) {
            let entity = this.inputPostalCodeExisting.getValue("entity");
            this.inputCountryExisting.setValue(entity ? entity.ref_country : null);
            this.inputCityExisting.setValue(entity, true);
            value = entity;

            this.setAttributeValue("existingAddress.city.isPlainText", isPlaintext);
            this.setAttributeValue("existingAddress.city.value", value);
        } else {
            if (!this.inputCityExisting.valueIsPlaintext) {
                this.inputCityExisting.setValue(null, true);

                this.setAttributeValue("existingAddress.city", null);
            }
            value = this.inputPostalCodeExisting.getValue();
        }
        this.setAttributeValue("existingAddress.postalCode.isPlainText", isPlaintext);
        this.setAttributeValue("existingAddress.postalCode.value", value);
        this._setInputCountryReadonly("existing");
    }

    private _onChangeCityExisting() {
        let isPlaintext = this.inputCityExisting.valueIsPlaintext;
        let value;
        if (!isPlaintext) {
            let entity = this.inputCityExisting.getValue("entity");
            this.inputCountryExisting.setValue(entity ? entity.ref_country : null);
            this.inputPostalCodeExisting.setValue(entity, true);
            value = entity;

            this.setAttributeValue("existingAddress.postalCode.isPlainText", isPlaintext);
            this.setAttributeValue("existingAddress.postalCode.value", value);
        } else {
            if (!this.inputPostalCodeExisting.valueIsPlaintext) {
                this.inputPostalCodeExisting.setValue(null, true);

                this.setAttributeValue("existingAddress.postalCode", null);
            }
            value = this.inputCityExisting.getValue();
        }
        this.setAttributeValue("existingAddress.city.isPlainText", isPlaintext);
        this.setAttributeValue("existingAddress.city.value", value);
        this._setInputCountryReadonly("existing");
    }

    private _onChangePostalCodeNew() {
        let isPlaintext = this.inputPostalCodeNew.valueIsPlaintext;
        let value;
        if (!isPlaintext) {
            let entity = this.inputPostalCodeNew.getValue("entity");
            this.inputCountryNew.setValue(entity ? entity.ref_country : null);
            this.inputCityNew.setValue(entity, true);
            value = entity;

            this.setAttributeValue("newAddress.city.isPlainText", isPlaintext);
            this.setAttributeValue("newAddress.city.value", value);
        } else {
            if (!this.inputCityNew.valueIsPlaintext) {
                this.inputCityNew.setValue(null, true);

                this.setAttributeValue("newAddress.city", null);
            }
            value = this.inputPostalCodeNew.getValue();
        }
        this.setAttributeValue("newAddress.postalCode.isPlainText", isPlaintext);
        this.setAttributeValue("newAddress.postalCode.value", value);
        this._setInputCountryReadonly("new");
    }

    private _onChangeCityNew() {
        let isPlaintext = this.inputCityNew.valueIsPlaintext;
        let value;
        if (!isPlaintext) {
            let entity = this.inputCityNew.getValue("entity");
            this.inputCountryNew.setValue(entity ? entity.ref_country : null);
            this.inputPostalCodeNew.setValue(entity, true);
            value = entity;

            this.setAttributeValue("newAddress.postalCode.isPlainText", isPlaintext);
            this.setAttributeValue("newAddress.postalCode.value", value);
        } else {
            if (!this.inputPostalCodeNew.valueIsPlaintext) {
                this.inputPostalCodeNew.setValue(null, true);
                this.setAttributeValue("newAddress.postalCode", null);
            }
            value = this.inputCityNew.getValue();
        }
        this.setAttributeValue("newAddress.city.isPlainText", isPlaintext);
        this.setAttributeValue("newAddress.city.value", value);
        this._setInputCountryReadonly("new");
    }

    private _onChangeCountryExisting() {
        let entity = this.inputCountryExisting.getValue("entity");
        this.setAttributeValue("existingAddress.country", entity);
    }

    private _onChangeCountryNew() {
        let entity = this.inputCountryNew.getValue("entity");
        this.setAttributeValue("newAddress.country", entity);
    }

    private _onChangeBankNo() {
        let entity = this.inputBankNo.getValue("entity");
        this.inputBIC.setValue(entity, true);

        this.setAttributeValue("bankAccount.bankNo", entity);
        this.setAttributeValue("bankAccount.bic.isPlainText", false);
        this.setAttributeValue("bankAccount.bic.value", entity);
        
    }

    private _onChangeBic() {
        let value;
        let isPlaintext = this.inputBIC.valueIsPlaintext;
        if (isPlaintext) {
            this.inputBankNo.setValue(null, true)
            value = this.inputBIC.getValue();

            this.setAttributeValue("bankAccount.bankNo", null);
        } else {
            let entity = this.inputBIC.getValue("entity");
            this.inputBankNo.setValue(entity, true);
            value = entity;

            this.setAttributeValue("bankAccount.bankNo", value);
        }
        let bic = {
            isPlainText: isPlaintext,
            value: value
        }
        //this.setAttributeValue("bankAccount.bic.", isPlaintext);
        this.setAttributeValue("bankAccount.bic", bic);
    }

    private _onChangeInput(mode: string, input: any) {
        let value = input.getValue();
        this.setAttributeValue(mode, value);
    }

    private _loadFileCategoriesList(): void {
        this.RequestManager.callfunction(
            "Webtool_API_TempInvoiceConfirmationEditor_GetFileCategories",
            {},
            lang.hitch(this, this._onLoadFileCategoriesResponse),
            lang.hitch(this, this._onLoadFileCategoriesError)
        )
    }

    private _onLoadFileCategoriesResponse(response): void {
        this.fileCategories = response;
    }

    protected _onUploadRowsCreated(rows: Array<any>): void {
        for (let row of rows) {
            let fileRow = row;

            //console.debug(this.id + " _onUploadRowCreated");

            let selectBox = new SearchSelect();

            selectBox.labelAttribute = "description";
            selectBox.setLabel(this.translations["General_Label_Category"]);
            selectBox.setSelectionListLEGACY(this.fileCategories);
            selectBox.setMandatory(true);

            let categoryToSet = this.fileCategories[0].ID;

            selectBox.on("change", lang.hitch(this, this._onChange_FileCategory, fileRow, selectBox));

            selectBox.setValue(categoryToSet);

            fileRow.addContent(selectBox.domNode);
        }
    }

    
    private _onChange_FileCategory(fileRow: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>, categorySelect: MdsLax<InstanceType<typeof SearchSelect>>, value: string): void {

        let file = fileRow.getData();
        let rowUploadGUID = file.uploadGUID
        let rowFileName = file.FileName;

        let targetUpload: VAM2types.FileUploadWithCategories = null;
        for (let upload of this.uploadUnits) {
            if (rowUploadGUID == upload.guid) {
                targetUpload = upload;
                break;
            }
        }

        let selectedCategory = categorySelect.getValue(true) as { ID: string, description: string };
        
        //if (fileToSave) fileToSave["fileCategoryID"] = value;
        if (targetUpload) {
            for (let categoryAssignment of targetUpload.fileCategories) {
                let count = 0;
                if (categoryAssignment.fileName == rowFileName) {
                    count++;
                    categoryAssignment.category = selectedCategory.ID;

                    this.uploadedFilesStore.setEntityAttributeValue(file.FileGUID, "ref_file_category", selectedCategory);

                }
            }
        }
    }

    private _onLoadFileCategoriesError(error): void {
        console.error(error);
    }

    private _onRemovedUpload(removedFile: FileUploadTypes.UploadDescriptor) {

        // TODO: Pseudoentry im Store finden (! mit guid und count nicht möglich, weils ja gerade entfernt worden ist!!) und entfernen,
        // damit sich die Liste neu zeichnet.
        var currentCompleteList = this.uploadedFilesStore.getCurrentCompleteList();
        var listItem: VAM2types.VtFiles;
        for (listItem as any of currentCompleteList) {
            if (listItem.ID.match(removedFile.uploadGUID) && listItem.filename === removedFile.FileName) {
                this.uploadedFilesStore.deleteEntry(listItem);
            }
        }
        //// Liste der Uploads aktualisieren:
        //for (let i = 0; i < this.uploadedFiles.length; i++) {
        //    let upload = this.uploadedFiles[i];
        //    if (removedFile.uploadGUID == upload.guid) {
        //        this.uploadedFiles.splice(i, 1);

        //        this._onChange_StoreData();

        //        this._onChangeUploadFile();
        //        return;
        //    }
        //}
    }

    private _onChangeUploadFile() {
        let uploadUnits = this.fileUpload.getValue();

        if (uploadUnits && this.fileUpload.validateInput()) {

            uploadUnits.forEach(uploadUnit => {

                let guid = uploadUnit.guid;
                let fileNames = uploadUnit.filenames
                let existingUploadUnit: VAM2types.FileUploadWithCategories = null;
                for (let upload of this.uploadUnits) {
                    if (upload.guid == guid) {
                        existingUploadUnit = upload;
                        break;
                    }
                }

                // wenns noch nicht im eigenne Array registriert ist: erweitern um Kategorien
                if (!existingUploadUnit) {
                    let exUnit = this.extendFileupload(uploadUnit);

                    this.uploadUnits.push(exUnit);

                    let count = 0;
                    for (let file of exUnit.files) {
                        count++;
                        let pseudofile: VAM2types.FileWithCategory = {
                            filename: file.FileName,
                            ref_file_category: this.fileCategories[0],
                            ID: file.FileGUID,
                            guid: exUnit.guid
                        }
                        this.uploadedFilesStore.addEntry(pseudofile);
                    }
                } else {
                    // Achtung, es könnte was entfernt worden sein
                    // bestehenden Upload-Datensatz nochmal updaten:
                    existingUploadUnit.filenames = uploadUnit.filenames;
                    existingUploadUnit.files = uploadUnit.files;
                }
            });


        } else {

        }
    }

    private extendFileupload(uploadData: FileUploadTypes.UploadUnit): VAM2types.FileUploadWithCategories {

        let pseudoFiles = [];
        let count = 0;
        let exFile: VAM2types.FileUploadWithCategories = {
            ...uploadData,
            fileCategories: [],
        }
        for (let filename of uploadData.filenames) {
            exFile.fileCategories.push({
                category: this.fileCategories[0].ID,
                fileName: filename
            })
        };


        return exFile;
    }

    private _onChangeFilesStore() {
        let data: EntityStoreData<VAM2types.VtFiles> = {
            changed: [],
            deleted: [],
            new: []
        };

        let storeData = this.uploadedFilesStore.getDiffData();

        data.new = this.uploadUnits as any;
        data.deleted = storeData.deleted;
        data.changed = storeData.changed as any;

        this.setAttributeValue("files", data);
        console.log(data);

    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setReadonly(false);

        this.createDefaultButton("save", lang.hitch(this, this._onClickSave), false);

        this.bookingsStore = new EntityStore();
        this._setupBookingsTable();

        this.filesStore = new EntityStore();
        this._setupFilesTable();

        this.uploadedFilesStore = new EntityStore();
        this.uploadedFilesStore.on("change", lang.hitch(this, this._onChangeFilesStore));

        this.inputAccountOwner.setReadonly(true);

        this.inputSalutation.on("change", lang.hitch(this, this._onChangeInput, "existingAddress.salutation", this.inputSalutation));
        this.inputNameFirst.on("change", lang.hitch(this, this._onChangeInput, "existingAddress.nameFirst", this.inputNameFirst));
        this.inputNameLast.on("change", lang.hitch(this, this._onChangeInput, "existingAddress.nameLast", this.inputNameLast));
        this.inputDayOfBirth.on("change", lang.hitch(this, this._onChangeInput, "existingAddress.dayOfBirth", this.inputDayOfBirth));
        this.inputStreet.on("change", lang.hitch(this, this._onChangeInput, "existingAddress.street", this.inputStreet));
        this.inputMail.on("change", lang.hitch(this, this._onChangeInput, "existingAddress.mail", this.inputMail));
        this.inputPhone.on("change", lang.hitch(this, this._onChangeInput, "existingAddress.phone", this.inputPhone));
        this.inputMobile.on("change", lang.hitch(this, this._onChangeInput, "existingAddress.mobile", this.inputMobile));
        this.inputGvl.on("change", lang.hitch(this, this._onChangeInput, "existingAddress.gvl", this.inputGvl));

        this.inputNewAddressDescription.on("change", lang.hitch(this, this._onChangeInput, "newAddress.description", this.inputNewAddressDescription));
        this.inputNewAddressName.on("change", lang.hitch(this, this._onChangeInput, "newAddress.name", this.inputNewAddressName));
        this.inputNewAddressStreet.on("change", lang.hitch(this, this._onChangeInput, "newAddress.street", this.inputNewAddressStreet));

        this.inputIBAN.on("change", lang.hitch(this, this._onChangeInput, "bankAccount.iban", this.inputIBAN));
        this.inputAccountNo.on("change", lang.hitch(this, this._onChangeInput, "bankAccount.accountNo", this.inputAccountNo));

        this.inputArrivalFrom.on("change", lang.hitch(this, this._onChangeInput, "arrival_from", this.inputArrivalFrom));
        this.inputReturnBackTo.on("change", lang.hitch(this, this._onChangeInput, "return_back_to", this.inputReturnBackTo));

        this.fileUpload.setup({ uploadCallback: lang.hitch(this, this._onUploadRowsCreated) });
        this.uploadUnits = [];
        this._loadFileCategoriesList();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TempInvoiceConfirmationEditor);